import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface PageLoaderProps {
  isVisible: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ isVisible }) => {
  // Prevent scrolling while loading
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  if (!isVisible) return null;
  
  // Use portal to ensure the loader is at the root level
  return createPortal(
    <div className="fixed top-0 left-0 w-full h-full bg-white/90 dark:bg-gray-900/90 flex items-center justify-center z-[9999]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-16 w-16 animate-spin">
          <svg className="text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            />
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
        <p className="text-lg font-semibold text-gray-900 dark:text-gray-100">Loading page...</p>
      </div>
    </div>,
    document.body
  );
};